var chunkToChildrenMap = {
	"2745": [
		3776,
		7094
	]
};
__webpack_require__.f.preload = (chunkId) => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.G);
};